<template>
  <div :class="cn('group absolute bottom-2 left-1/2 flex -translate-x-1/2 items-center justify-start gap-x-1', shouldShowByDefault ? 'md:flex' : 'md:hidden md:group-hover:flex')">
    <div v-for="(_, index) in visibleDots" :key="index">
      <div :class="cn('h-1 w-1 rounded-full', index + startIndex === selectedIndex ? 'w-4 bg-light-bg-default' : 'bg-dark-bg-overlay')" @click="(e) => onClickScrollTo(e, index + startIndex)" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { cn } from '@/components/lib/shadcn-vue/utils';

interface Props {
  shouldShowByDefault?: boolean;
  selectedIndex: number;
  totalItemCount: number;
  onClickScrollTo: (e: MouseEvent, index: number) => void;
}

const props = defineProps<Props>();

const MAX_VISIBLE_DOTS = 7;

const startIndex = computed<number>(() => {
  if (props.totalItemCount <= MAX_VISIBLE_DOTS) {
    return 0;
  }
  if (props.selectedIndex <= 3) {
    return 0;
  }
  if (props.selectedIndex >= props.totalItemCount - 4) {
    return props.totalItemCount - MAX_VISIBLE_DOTS;
  }

  return props.selectedIndex - 3;
});

/**
 * 動的にDot indicatorの数を生成する。 * 画像数が7枚を超える場合でも、dotsの最大表示数は7に固定する。
 * 例）画像が12枚あった場合、Dot数は7件で、4〜9枚目の表示の際は選択されているIndexを示すdotを中央に表示する。
 */
const visibleDots = computed<number[]>(() => {
  if (props.totalItemCount <= MAX_VISIBLE_DOTS) {
    return Array.from({ length: props.totalItemCount }, (_, index) => index + 1);
  }

  return Array.from({ length: MAX_VISIBLE_DOTS }, (_, index) => index + startIndex.value);
});
</script>
